import { useState, useEffect, useRef } from "react";
import { Header } from "../../common/Header/Header.jsx";
import { PendingAVFaultsResolvedTable } from "../../common/Tables/Tables.jsx";
import { PendingAVFaultsResolvedHeader } from "../../../assets/helpers/tables.js";
import { notify } from "../../../assets/helpers/toast.js";
import { FilterDatePicker } from "../../common/Forms/Input/Input.jsx";
import moment from "moment";
import { filterParams } from "../../../assets/helpers/funciones.js";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";
import { servicesService } from "../../../services/servicesService.js";
import { UpdateAVResolvedModal } from "../../common/Modals/Modals.jsx";

const itemsPerpage = [10, 25, 50, 100, 500];

const ApproveAVFaultsResolved = () => {
  const tableRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState(new Date(moment()));
  const [showUpdateFaultModal, setShowUpdateAVFaultModal] = useState({
    show: false,
    id: "",
    status: "",
  });
  const [solvedFaultTable, setSolvedFaultTable] = useState({
    limit: itemsPerpage[2],
    offset: 0,
    data: [],
    count: 0,
    page: 1,
    date: moment(),
    isLoading: false,
    searchParam: "",
  });

  const setFirstPage = () => {
    setSolvedFaultTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handlePageChange = (event, value) => {
    setSolvedFaultTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * solvedFaultTable?.limit,
      };
    });
  };

  const handleDateChange = (e) => {
    setDate(e);
    setSolvedFaultTable((prevState) => ({
      ...prevState,
      date: e,
    }));
    setFirstPage();
  };

  useEffect(() => {
    getSolvedFaultData();
  }, [
    solvedFaultTable?.page,
    solvedFaultTable?.offset,
    solvedFaultTable?.limit,
    date,
  ]);

  const handleAVFault = (id, status) => {
    setShowUpdateAVFaultModal((prevState) => ({
      ...prevState,
      show: true,
      id,
      status,
    }));
  };

  const updateAVFault = async (id, status) => {
    setIsLoading(true);
    servicesService
      .uptateSolvedFaultServices(id, { status })
      .then((response) => {
        if (response.status === 200) {
          notify(`Servicio ${status} correctamente.`, "success");
          setShowUpdateAVFaultModal((prevState) => ({
            ...prevState,
            show: false,
            id: "",
            status: "",
          }));
          getSolvedFaultData();
          setIsLoading(false);
        } else {
          notify(`${response.message}` || "error", "error");
          setShowUpdateAVFaultModal((prevState) => ({
            ...prevState,
            show: false,
            id: "",
            status: "",
          }));
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setShowUpdateAVFaultModal((prevState) => ({
          ...prevState,
          show: false,
          id: "",
          status: "",
        }));
        setIsLoading(false);
      });
    return true;
  };

  const getSolvedFaultData = () => {
    let params = {
      date: date ? moment(date).format("MM-DD-YYYY") : null,
      limit: solvedFaultTable?.limit,
      offset: solvedFaultTable?.offset,
    };
    setIsLoading(true);

    servicesService
      .getsolvedFaultServices(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setSolvedFaultTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.services,
              count: response?.data?.total,
              isLoading: false,
            };
          });
          setIsLoading(false);
        } else {
          notify(`${response.message}` || "error", "error");
          setSolvedFaultTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setSolvedFaultTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
        setIsLoading(false);
      });
    return true;
  };

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <UpdateAVResolvedModal
        show={showUpdateFaultModal}
        handleClose={() => {
          setShowUpdateAVFaultModal((prevState) => ({
            ...prevState,
            show: false,
            id: "",
            status: "",
          }));
        }}
        action={updateAVFault}
      />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">{`Aprobación Averías Resueltas`}</h1>
        </div>
        <hr
          style={{
            marginBottom: "0px",
          }}
        />
        <div className="breadcrumb-container">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <FilterDatePicker
                bootstrap={"col-12 col-md-2"}
                label={"Fecha"}
                type={"date"}
                name={"date"}
                placeholder={""}
                onChange={handleDateChange}
                value={date}
                disabled={solvedFaultTable?.isLoading}
              />
            </div>
          </div>
        </div>
        <PendingAVFaultsResolvedTable
          header={PendingAVFaultsResolvedHeader}
          data={solvedFaultTable}
          handlePageChange={handlePageChange}
          tableRef={tableRef}
          date={date}
          action={handleAVFault}
        />
      </div>
    </>
  );
};

export default ApproveAVFaultsResolved;
